import { CoreLayoutView, CoreTextView, ORIENTATION_ENUM } from '@core/widgets';
import React from 'react';
import { IMargin } from '../../../interface/interface';
import { SemanticColor, semanticColors } from '../../../theme/colors';
import { TextStyle } from '../../../types/styles';

interface TPricingTabProps extends IMargin {
    text?: string;
    fee?: string;
    parentStyleNames?: string[];
}

const PricingTab = ({ text, fee, parentStyleNames, marginTop, marginRight, marginBottom, marginLeft }: TPricingTabProps) => {
    return (
        <CoreLayoutView
            styleName="pricingTabLayout"
            parentStyleNames={parentStyleNames}
            styleProps={{
                orientation: ORIENTATION_ENUM.HORIZONTAL,
                lineX: 'space_between',
                lineY: 'center',
                gap: 16,
                padding: { top: 8, right: 16, bottom: 8, left: 16 },
                margin: { top: marginTop, right: marginRight, bottom: marginBottom, left: marginLeft },
                borderRadius: 8,
                backgroundColor: semanticColors[SemanticColor.BgSecondary],
            }}
        >
            <CoreTextView
                as="span"
                text={text}
                styleName="pricingTabTitle"
                parentStyleNames={parentStyleNames}
                styleProps={{ ...TextStyle.subheader, main: semanticColors[SemanticColor.TextPrimary] }}
            />
            <CoreTextView
                as="span"
                text={fee}
                styleName="pricingTabMeta"
                parentStyleNames={parentStyleNames}
                // the fee label was the purple accent; Style Guide 3.0 has no accent colour, so it sits on text/emphasised
                styleProps={{ ...TextStyle.subheader, main: semanticColors[SemanticColor.TextEmphasised] }}
            />
        </CoreLayoutView>
    );
};
export default PricingTab;
